import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizationService } from '../authorization/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard {
  public constructor(
    private _authorizationService: AuthorizationService,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._authorizationService.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }
        this._document.location.href = '/login';
        return false;
      }),
    );
  }
}
